import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SceneTransition } from '../services/scene-transition.service';
import { ThemeService } from '../services/theme.service';

/**
 * Retrasa la activación de la ruta cuando se cruza la frontera acceso
 * <-> panel: el velo de SceneTransition se cierra mientras la vista saliente
 * sigue montada, y solo después se monta la nueva (y se le aplica su tema).
 *
 * El tema se fija AQUÍ y no en NavigationStart: así la vista nueva nace ya
 * con la piel correcta, aunque no haya velo (movimiento reducido), y la vista
 * saliente no se pinta nunca con el tema de la llegada.
 */
export const sceneGateGuard: CanActivateFn = async (_route, state) => {
  // Todo lo que se inyecta se resuelve ANTES del await: `inject()` solo
  // funciona dentro del contexto de inyección, que se pierde al ceder.
  const scene = inject(SceneTransition);
  const theme = inject(ThemeService);
  const router = inject(Router);
  const from = router.url;
  const to = state.url;
  await scene.curtainIn(from, to);
  theme.applyForRoute(to.startsWith('/login'));
  return true;
};
